import React from "react";
import { WarehouseStockDto } from "../../../api/warehouseStock";

interface Props {
  items: WarehouseStockDto[];
}

export default function StockTable({ items }: Props) {
  return (
    <table className="stock-table">
      <thead>
        <tr>
          <th className="st-photo">Фото</th>
          <th className="st-name">Название</th>
          <th className="st-cat">Категория</th>
          <th className="st-type">Тип</th>
          <th>Остаток</th>
          <th>Статус</th>
        </tr>
      </thead>

      <tbody>
        {items.map((s) => {
          const p = s.product;
          const qty = s.quantity ?? 0;

          return (
            <tr key={s.productId}>
              <td className="st-photo">—</td>
              <td className="st-name">{p.nameRu}</td>
              <td className="st-cat">{p.category?.name ?? "—"}</td>
              <td className="st-type">{p.type === "service" ? "Услуга" : "Товар"}</td>
              <td className="st-qty">{p.type === "service" ? "—" : qty}</td>

              <td className="st-status">
                {p.type === "service" && <div className="tag-service">Услуга</div>}
                {p.type === "product" && qty === 0 && <div className="tag-out">Нет в наличии</div>}
                {p.type === "product" && qty > 0 && <div className="tag-in">В наличии</div>}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
